import { render } from "./formApplicationSubsidy.vue?vue&type=template&id=af967fa4"
import script from "./formApplicationSubsidy.vue?vue&type=script&lang=js"
export * from "./formApplicationSubsidy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__